<template>
  <div class="remove_table_shadow">
    <app-modal
        modal-id="guest-info"
        v-if="setModal === true"
        modal-size="md"
        data-backdrop="static"
        data-keyboard="false"
        style="background:rgba(0, 0, 0, .5)">
      <div class="modal-body d-flex flex-column justify-content-center modal-alert" style="margin-top:30px" >
        <div class="text-center">
          <app-icon class="text-warning" :name="'alert-triangle'"/>
        </div>
        <h5 class="text-center font-weight-bold mt-4">{{ $t('Notice')+'!' }}</h5>
        <p class="text-center font-size-90">{{ $t('Please fill in the required details:') }}</p>
        <div class="form-group row">
          <el-form v-if="active === 1">
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form" :data-url="addUrl">
              <div class="form-group row align-items-center">
                <label for="guestInfo_name" class="col-sm-3 mb-0">
                  {{ $t("name") }}
                </label>
                <app-input
                    id="guestInfo_name"
                    class="col-sm-9"
                    type="text"
                    v-model="guestInfo.name"
                    :placeholder="$t('name')"
                    :required="true"
                />
              </div>
              <div class="form-group row align-items-center">
                <label for="guestInfo_email" class="col-sm-3 mb-0">
                  {{ $t("email") }}
                </label>
                <app-input
                    id="guestInfo_email"
                    class="col-sm-9"
                    type="email"
                    v-model="guestInfo.email"
                    :placeholder="$t('email')"
                    :required="true"
                />
              </div>
              <div class="form-group row align-items-center">
                <div class="col-sm-3 mb-3">
                  <label for="guestInfo_businessName" >
                    {{ $t("Business Name / Ref") }}
                  </label>
                </div>
                <div class="col-sm-9">
                  <app-input
                      id="guestInfo_businessName"
                      type="text"
                      :placeholder="$t('company_name')"
                      v-model="guestInfo.company_name"
                  />
                </div>
              </div>
            </form>
          </el-form>
        </div>

        <div class="text-center">
          <app-button
              :label="$t('submit')"
              class-name="btn-success mr-2"
              :is-disabled="false"
              @submit="saveForm"
          />

        </div>
      </div>


    </app-modal>

    <el-form v-if="active === 1">
      <app-table
        :id="tableId"
        :options="options"
        @action="getListAction"
    />
    </el-form>
    <el-form v-if="active === 2">
      <guest-form-preview @back="backToListing" :id="taskId"
                          :form_id="formId" :formBodyId="formBodyId"
                          :form_revision_id="formRevisionId" :taskId="taskId"
                 :guestUuid="guestUuid" :active="active">
      </guest-form-preview>
    </el-form>
    <task-forms-view-modal
        v-if="isFormModalActive"
        :table-id="tableId"
        :selected-url="selectedUrl"
        :id="formId"
        @close-modal="closeFormModal"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary";
import * as actions from "../../../../../Config/ApiUrl";
import {TableHelpers} from "../../../Demo/Tables/mixins/TableHelpers";
import {axiosGet, axiosPost} from "../../../../../Helpers/AxiosHelper.js";
import {GUEST_USER_INFO} from "../../../../../Config/ApiUrl";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import ModalMixin from "@/app/Mixins/global/ModalMixin";

export default {
  extends: CoreLibrary,
  name: "GuestFormsListing",
  mixins: [TableHelpers, FormMixin, ModalMixin],
  data() {
    return {
      type: '',
      setModal: true,
      active: 1,
      formId: 0,
      formRevisionId: 0,
      guestInfo: {},
      formBodyId: 0,
      guestUuid: 0,
      taskId: 0,
      packages: {},
      isFormModalActive: false,
      preloader: false,
      selectedUrl: "",
      tableId: "guest-forms-listing",
      options: {
        name: "GuestFormsTable",
        url: actions.TASK_ASSIGN_FORMS,
        showHeader: true,
        columns: [
          {
            title: this.$t("name"),
            type: "custom-html",
            key: "form",
            modifier: (value, row) => {
              return `<a href="#" id="${row.id}" @click=${this.myFunction(row)}>${this.$t(value.name)}</a>`;
            },
          },
          {
            title: this.$t("description"),
            type: "custom-html",
            key: "form",
            modifier: (value) => {
              return `<span>${this.$t(value.description ?? '---')}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "user_task_form_status",
            isVisible: true,
            modifier: (value, row) => {
              let ClassName = "danger";
              let val = "Un Read";

              if (value?.status === 'submitted') {
                ClassName = `primary`;
                val = "Submitted";
              } else if (value?.status === 'pending' || value?.status === 'draft') {
                ClassName = `dark`;
                val = "Pending";
              } else if (value?.status === 'action-required') {
                ClassName = `warning`;
                val = "Action Required";
              } else if (value?.status === 'accepted' || value?.status === 'approved') {
                ClassName = `success`;
                val = "Approved";
              }

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                  val
              )}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
        ],

        showFilter: false,
        showSearch: false,
        showCount: true,
        showClearFilter: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",

      },
      addUrl: GUEST_USER_INFO,
    };
  },
  created() {
    this.setProps();
    this.options.columns = [...this.options.columns, this.actionObj];

  },
  methods: {
    afterSuccess(res) {
      this.$toastr.s(res.data.message);

      this.options.url = this.options.url + '/' + this.taskId+'/'+ '?gustUuid='+this.guestUuid + '&user_id='+res.data.payload.id;

      this.$hub.$emit('reload-' + this.tableId, false);

      this.$store.commit('updateSharedData', {index: "guestUserData", newValue: res.data.payload})
      $('#guest-info').modal('hide');
      this.guestUser = res.data.payload;
    },
    afterError(res) {
      if(res && res.data)
      this.$toastr.e(res.data.message);
    },
    saveForm(){
      this.save(this.guestInfo);
    },

    backToListing(){
      this.active = 1
    },
    setProps() {
      this.taskId = this.$attrs.taskdata.task_id;
      this.formRevisionId = this.$attrs.taskdata.form_revision_id;
      this.guestUuid = this.$attrs.taskdata.guest_uuid;
      this.$store.commit('updateSharedData', {index: "guestTaskAttrs", newValue: this.$attrs})

    },
    certificateIssue() {
      this.certificatedata.certificate_id = this.$attrs['props'].certificate_id;
      this.certificatedata.company_id = this.$attrs['props'].company_id;
      this.deleteConfirmationModalActive = true;
    },
    openFormModal() {
      this.isFormModalActive = true;
    },
    closeFormModal() {
      $("#form-view-Modal").modal("hide");
      this.isFormModalActive = false;
      //   this.searchAndSelectFilterOptions();
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t("view")) {
        this.view(rowData);
        // this.openFormModal();
      }
    },
    view(rowData) {
      this.formId = rowData.form.id;
      this.formRevisionId = rowData.id;
      this.formBodyId = rowData.form_body_id;
      this.active = 2;
    },
    myFunction(data) {
      let doc = document.getElementById(data.id);
      if (doc) {
        doc.addEventListener('click', () => {
          this.view(data);
        });
      }
    },


  },
  mounted() {
    // this.options.url = this.options.url + '/' + this.taskId+'/'+ '?gustUuid='+this.guestUuid + '&user_id='+this.$store.state.sharedData.sharedData?.guestUserData?.id;
    let myLocation = location.href;
    let split = myLocation.split("/");
    this.type = split[3].split("?")[0];
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
<style scoped>
.remove_table_shadow .h-100 .datatable .table-responsive {
  box-shadow: none !important;
}
</style>
